import { Feature, PlanInterval, SubscriptionPlanPrice } from '../models';

const PLAN_INTERVAL_POSTFIX: Partial<Record<PlanInterval, string>> = {
  [PlanInterval.MONTH]: 'Monthly',
  [PlanInterval.YEAR]: 'Annually',
};

const DEFAULT_PRICE: Partial<Record<Feature, Partial<Record<PlanInterval, number>>>> = {
  [Feature.TRUE_TEAM]: {
    [PlanInterval.MONTH]: 185,
    [PlanInterval.YEAR]: 2000,
  },
  [Feature.TESTCLOUD_SESSION_CROSS_BROWSER]: {
    [PlanInterval.MONTH]: 140,
    [PlanInterval.YEAR]: 1500,
  },
  [Feature.TESTCLOUD_SESSION_MOBILE_APP]: {
    [PlanInterval.MONTH]: 175,
    [PlanInterval.YEAR]: 1899,
  },
  [Feature.TESTCLOUD_SESSION_PRIVATE_DEVICE]: {
    [PlanInterval.MONTH]: 600,
    [PlanInterval.YEAR]: 6600,
  },
};

const DEFAULT_DISCOUNT_PRICE: Partial<Record<Feature, Partial<Record<PlanInterval, number>>>> = {
  [Feature.TRUE_TEAM]: {
    [PlanInterval.YEAR]: 800,
  },
};

export const getUnitPrice = (
  planPrice: SubscriptionPlanPrice | undefined,
  feature: Feature,
  interval: PlanInterval,
): number => {
  const postfix = PLAN_INTERVAL_POSTFIX[interval];
  if (planPrice && postfix) {
    const key = `${Feature.getFeaturePrefix(feature)}${feature === Feature.TRUE_TEAM ? '' : 'AddOn'}${postfix}` as keyof SubscriptionPlanPrice;
    const unitPrice = planPrice[key];

    if (typeof unitPrice === 'number') {
      return unitPrice;
    }
  }

  return DEFAULT_PRICE[feature]?.[interval] ?? 0;
};

export const getDiscountPrice = (
  planPrice: SubscriptionPlanPrice | undefined,
  feature: Feature,
  interval: PlanInterval,
): number => {
  const postfix = PLAN_INTERVAL_POSTFIX[interval];
  if (planPrice && postfix) {
    const key = `${Feature.getFeaturePrefix(feature)}Discount${postfix}` as keyof SubscriptionPlanPrice;
    const unitPrice = planPrice[key];

    if (typeof unitPrice === 'number') {
      return unitPrice;
    }
  }

  return DEFAULT_DISCOUNT_PRICE[feature]?.[interval] ?? 0;
};

export const useCalculatePrice = (
  planPrice: SubscriptionPlanPrice | undefined,
  features: Partial<Record<Feature, number>>,
  interval: PlanInterval,
): number => Object.entries(features).map(([feature, quantity]) => {
  if (!Number.isFinite(quantity) || quantity <= 0) {
    return 0;
  }

  const unitPrice = getUnitPrice(planPrice, feature as Feature, interval);
  return unitPrice * quantity;
}).reduce((prev, curr) => prev + curr, 0);
